import React from "react"
import { css } from "styled-components"
import { VerticalGradient } from "src/frontend/components/OS/Shared/Charts/Coloring"

// The aging chart uses gradients that are not used in other charts
export const useAgingChartAdditionalGradients = (chartId: string) =>
  React.useMemo(
    () => (
      <>
        <VerticalGradient id={`${chartId}-current`} color="#AEF2DA" bottomColor="#BEFEF3" />
        <VerticalGradient id={`${chartId}-30`} color="#FFF2A1" bottomColor="#FFF2C3" />
        <VerticalGradient id={`${chartId}-60`} color="#FFD9B5" bottomColor="#FFDAA1" />
        <VerticalGradient id={`${chartId}-90`} color="#FFB5A6" bottomColor="#FFC5CF" />
        <VerticalGradient id={`${chartId}-older`} color="#FFB5A6" bottomColor="#FFC5CF" />
      </>
    ),
    [chartId]
  )

export const additionalGradientStyles = ({ chartId }: { chartId: string }) => css`
  svg {
    .visx-bar:has(~ .visx-bar[fill="url(#${chartId}-bar-fill)"]) {
      fill: url(#${chartId}-bar-fill-inactive);
    }
    .visx-bar[fill="url(#${chartId}-bar-fill)"] ~ .visx-bar {
      fill: url(#${chartId}-bar-fill-inactive);
    }
    .visx-bar:nth-child(1) {
      fill: url(#${chartId}-current);
    }
    .visx-bar:nth-child(3) {
      fill: url(#${chartId}-30);
    }
    .visx-bar:nth-child(5) {
      fill: url(#${chartId}-60);
    }
    .visx-bar:nth-child(7) {
      fill: url(#${chartId}-90);
    }
    .visx-bar:nth-child(9) {
      fill: url(#${chartId}-older);
    }
  }
`
